import {
  WSActions,
  WSCard,
  WSEmptyState,
  WSInfoBox,
  WSList
} from "@wingspanhq/fe-component-library";
import { useRef } from "react";
import { useHistory } from "react-router-dom";
import { queriesTaxWithholdings } from "@query";
import { Layout } from "../../../shared/components/Layout";
import {
  CardOptOutSurvey,
  CardOptOutSurveyRef
} from "../components/CardOptOutSurvey";
import { PATH_TAX_WITHHOLDINGS } from "../paths";

export const RouteSurvey = () => {
  const history = useHistory();

  const surveyRef = useRef<CardOptOutSurveyRef>(null);

  const [updateSettings, updateSettingsMeta] =
    queriesTaxWithholdings.updateTaxWithholdingSettings.useMutation();

  return (
    <Layout title="Tax Withholdings">
      <WSList gap="2XL">
        <WSCard>
          <WSEmptyState
            orientation="horizontal"
            type="tasks"
            title="You’ve turned tax withholdings off"
            description={
              <WSInfoBox transparent>
                <p>
                  You’ve opted out of tax withholdings for now. Here’s what to
                  remember:
                </p>
                <ul>
                  <li>Quarterly deadlines: Apr 15, Jun 15, Sep 15, Jan 15</li>
                  <li>Set aside 25-30% of income for taxes</li>
                  <li>Use IRS Form 1040-ES for payments</li>
                  <li>Keep detailed income records</li>
                </ul>
                <p>
                  You can enable tax withholding anytime under your “Financial
                  benefits” section.
                </p>
              </WSInfoBox>
            }
          />
        </WSCard>

        <CardOptOutSurvey ref={surveyRef} />

        <WSActions
          orientation="vertical"
          buttons={[
            {
              label: "Continue",
              onClick: () => {
                surveyRef.current?.submit();
                history.push(PATH_TAX_WITHHOLDINGS);
              }
            },
            {
              kind: "Link",
              label: "I changed my mind, turn it back on",
              loading: updateSettingsMeta.isLoading,
              onClick: () => {
                updateSettings(
                  {
                    taxWithholdingSettingsUpdate: { isEnabled: true }
                  },
                  {
                    onSuccess: () => {
                      history.push(PATH_TAX_WITHHOLDINGS);
                    }
                  }
                );
              }
            }
          ]}
        />
      </WSList>
    </Layout>
  );
};
